import {routesPosition, RoutesProps} from '../router.config';
import {ColumnExportConstants, TicketCategoryConstants} from '../../constants/model';
import {Roles} from "../../model/Group";
import FilterController from "../../components/FilterController";
import Kanban, {KanbanColumn} from "../../components/Kanban/Kanban";
import ShipmentKanbanCard from "../../components/app/App/shipment-kanban-card";
import {TicketNormalizer} from "../../services/normalizer/ticketNormalizer";
import KanbanFilter from "../../forms/app/filters/kanban-filter";
import {Ticket} from "../../model/Ticket";
import AccessControl from "../../components/access-control";
import ExportType from "../../forms/app/types/export-type";


interface OrderByDateOptions {
    resetTime: boolean;
}

const columnOrderByDate = (
    aDate: [string, Date | null],
    bDate: [string, Date | null],
    options?: OrderByDateOptions
): number => {
    const [, aLoadingDate] = aDate;
    const [, bLoadingDate] = bDate;

    if (options && options.resetTime) {
        aLoadingDate?.setHours(0, 0, 0, 0);
        bLoadingDate?.setHours(0, 0, 0, 0);
    }

    if (aLoadingDate === null) {
        return 1;
    }
    if (bLoadingDate === null) {
        return -1;
    }

    // le +(Date) permet de cast en number la date (Timestamp) pour faire la comparaison
    return (+aLoadingDate - +bLoadingDate);
};

const columns: KanbanColumn<Ticket>[] = [
    {
        label: 'Mise en place',
        col: ColumnExportConstants.START,
        orderBy: {'shipment.createdAt': 'DESC', 'shipment.referenceMyTrucks': 'DESC'},
    },
    {
        label: 'Transport',
        col: ColumnExportConstants.TRANSPORT,
        orderBy: {'preRoutingDate': 'ASC'},
    },
    {
        label: 'Douane',
        col: ColumnExportConstants.CUSTOMS,
        orderBy: {'shipment.mainClosingDate': 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                ['',a.shipment.mainClosingDate],
                ['',b.shipment.mainClosingDate]
            );
        },
    },
    {
        label: 'Documentation',
        col: ColumnExportConstants.DOCUMENTATION,
        orderBy: {'shipment.docClosingDate': 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                ['',a.shipment.docClosingDate],
                ['',b.shipment.docClosingDate]
            );
        },
    },
    {
        label: 'Embarquement',
        col: ColumnExportConstants.LOADING,
        orderBy: {departureDate: 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                a.shipment.displayedLoadingDate,
                b.shipment.displayedLoadingDate
            );
        },
    },
    {
        label: 'Facturation',
        col: ColumnExportConstants.BILLING,
        orderBy: {departureDate: 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                a.shipment.displayedLoadingDate,
                b.shipment.displayedLoadingDate
            );
        },
    },
];

export const exportRoutes: RoutesProps = {
    icon: 'fas fa-plane-departure',
    name: 'Export',
    path: '/export/',
    position: routesPosition.leftSideBar,
    handle: {
        crumb: 'Export',
    },
    accessControl: [Roles.ROLE_WORKFLOW_EXPORT_SHOW, Roles.ROLE_SUPER_ADMIN],
    children: [
        {
            path: '/export/',
            element: <AccessControl roles={[Roles.ROLE_WORKFLOW_EXPORT_SHOW, Roles.ROLE_SUPER_ADMIN]}>
                <FilterController
                    renderFilterable={(props) =>
                        <Kanban
                            {...props}
                            renderCard={(ticket) =>
                                <ShipmentKanbanCard ticket={ticket}/>
                            }
                            columns={columns}
                            colSize={2}
                            namespace={'workflow_tickets'}
                            normalizer={TicketNormalizer}
                            getDoubleClickUrl={(ticket) => `/export/${ticket.id}`}
                        />
                    }
                    filterDefault={{
                        category: TicketCategoryConstants.CATEGORY_EXPORT,
                        'shipment+archived': false,
                        managedByMe: true
                    }}
                    renderFilter={(props) => <KanbanFilter {...props} />}
                />
            </AccessControl>,
            position: routesPosition.hiddenRoutes
        },
        {
            path: '/export/:id',
            element: <ExportType/>,
            handle: {
                crumb: 'Dossier',
            },
            position: routesPosition.hiddenRoutes,
        }
    ]
};
